import i18next from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

export class Translations
{
    static init() {
        i18next.init({
            fallbackLng: "en",
           debug: false,
           resources: {
            nl: {
                translation: {
                    "tut0": "Het aftellen van de tijd staat nog even op pauze\nzodat je rustig kan leren spelen.\nOm te bewegen gebruik je de linkerhendel.",
        "tut1": "Om een bloem te plukken ga je naar een bloempot en druk je op A.",
        "tut2": "Zet een bloem in een lege vaas door erheen te gaan en op A te drukken.",
        "tut3": "Combineer nu 3, 4 of 5 letters op 1 van de 3\naansluitende tafels om een woord te vormen.",
        "tut4": "Gelukt! Hoe langer het woord, hoe meer punten.\nZoals je ziet staat er ook een roze gieter in de serre.\nNeem hem op door op A te drukken.",
        "tut5": "Je kan met de gieter langs lege bloempotten wandelen\nom te zorgen dat er direct bloemen groeien.\nEr vliegt ook een bijtje rond dat bloempotten bestuift.\nDruk op A om de gieter terug neer te zetten.",
        "tut6": "Zoals je ziet kan je met maximum 4 spelers samen spelen.\nJe weet nu alles wat je moet weten!\nProbeer nu zo snel mogelijk woorden te vormen.\nJe hebt 5 minuten de tijd. Succes!",
                    "menustart": 'Druk A om te starten',
                    "menustarttut": '\nof X om nog eens de tutorial te volgen',
                    "youwin": 'Je hebt gewonnen!',
                    "exit": "Blijven spelen? (A)\nStoppen? (B)",
                    "score": "Score: ",
                    "setlanguage": "Verander de taal (Y)",
                    "menustartkeyboard": 'Druk spatie om te starten',
                    "menustarttutkeyboard": '\nof T om nog eens de tutorial te volgen',
                    "exitkeyboard": "Blijven spelen? (spatie)\nStoppen? (Q)",
                    "setlanguagekeyboard": "Verander de taal (L)"
                }
            },
            en: {
                translation: {
                    "tut0": "The time countdown is paused for a while\nso you can learn to play quietly.\nTo move, use the left stick.",
        "tut1": "To pick a flower, go to a flower pot and press A.",
        "tut2": "Put a flower in an empty vase by going to it and pressing A.",
        "tut3": "Now combine 3, 4 or 5 letters on 1 of the\n3-letter tables to form a word.",
        "tut4": "Success! The longer the word, the more points.\nAs you can see, there is also a pink watering can in the greenhouse.\nPick it up by pressing A.",
        "tut5": "You can walk past empty flower pots with the watering can\n to make sure flowers grow immediately.\nThere is also a bee flying around pollinating flower pots.\nPress A to put the watering can back down.",
        "tut6": "As you can see, you can play with up to 4 players together.\nYou now know everything you need to know.\nNow try to form words as fast as you can.\nYou have 5 minutes. Good luck!",
                    "menustart": 'Press A to start',
                    "menustarttut": '\nor X to follow the tutorial again',
                    "youwin": 'You won!',
                    "exit": "Keep playing? (A)\nStop? (B)",
                    "score": "Score: ",
                    "setlanguage": "Change language (Y)",
                    "menustartkeyboard": 'Press space to start',
                    "menustarttutkeyboard": '\nor T to follow the tutorial again',
                    "exitkeyboard": "Keep playing? (space)\nStop? (Q)",
                    "setlanguagekeyboard": "Change language (L)",
                }
            }
           } 
        });

        i18next.use(LanguageDetector);
    }
}